.uploadContainer {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background-color: #fcfbff;
	height: 100%;
	width: 100%;
	border-radius: 4px;
	border: 0.83px dashed rgba(66, 41, 110, 1);
	gap: 0.5rem;
	padding: 0.5rem;
	box-sizing: border-box;
}

.dragActive {
	background-color: #f1edff;
}

.dragAndDropText {
	font-weight: 400;
	font-size: 14px;
	margin-top: 18px;
	margin-bottom: 10px;
}

@media (max-width: 400px) {
	.csvBox {
		height: 180px;
	}
}
